import { Step } from '@betterleap/client';

export const MANUAL_STEPS = [
  Step.type.INMAIL,
  Step.type.PHONE_CALL,
  Step.type.SMS,
  Step.type.X_DIRECT_MESSAGE,
];
export const AUTOMATED_STEPS = [Step.type.EMAIL];
